import { ConfirmModal } from '@client/components/_ui/feedback/confirm-modal';
import { useInitMessage } from '@client/components/_ui/feedback/message';
import { useInitModal } from '@client/components/_ui/feedback/modal';
import { useInitNotification } from '@client/components/_ui/feedback/notification';
import { antdSpinConfig, getAntdTheme } from '@client/design-system/antd-theme';
import { useThemeStore } from '@client/stores/themeStore';
import '@client/styles/main.css';
import { App, ConfigProvider } from 'antd';
import clsx from 'clsx';
import { type PropsWithChildren, useMemo } from 'react';

function UISetup({ children }: PropsWithChildren) {
    useInitMessage();
    useInitNotification();
    useInitModal();

    return (
        <>
            {children}
            <ConfirmModal />
        </>
    );
}

export function UIProvider({ children }: PropsWithChildren) {
    const resolvedTheme = useThemeStore((state) => state.resolvedTheme);
    const isDark = resolvedTheme === 'dark';

    const theme = useMemo(() => getAntdTheme(isDark), [isDark]);

    return (
        <ConfigProvider
            theme={theme}
            spin={antdSpinConfig}
            modal={{
                mask: {
                    blur: false,
                },
            }}
            drawer={{
                mask: {
                    blur: false,
                },
            }}
            form={{
                requiredMark(label, info) {
                    return info.required ? (
                        <span
                            className={clsx(
                                "pl-2.5 before:mr-1 before:text-ui-error before:text-xs before:content-['*']",
                                'before:absolute before:-translate-x-2.5 before:translate-y-0.5',
                            )}
                        >
                            {label}
                        </span>
                    ) : (
                        label
                    );
                },
            }}
        >
            <App className="flex min-h-screen" message={{ maxCount: 1 }}>
                <UISetup>{children}</UISetup>
            </App>
        </ConfigProvider>
    );
}
